import { createSelector } from 'reselect';

import { hasLegacyClaimPageConfig } from '../../../utils/campaigns';
import { IAppState } from '../../reducers';
import { selectCsSelectedKit } from './contents';

export const selectCsClaimPageState = (state: IAppState) => state.createSend.claimPage;

export const selectCsClaimPageExperienceId = createSelector(selectCsClaimPageState, (claim) => claim.experienceId);

export const selectCsHasLegacyClaimPageConfig = createSelector(selectCsSelectedKit, hasLegacyClaimPageConfig);
